export enum TransportOffering {
  OFFERS_TRANSPORT = 'OFFERS_TRANSPORT',
  NO_TRANSPORT = 'NO_TRANSPORT',
}
